import { FreezingLevel } from './marker-content-freezing.js';
import { MarineConditions } from './marker-content-marine.js';
import { SkiStatus } from './marker-content-ski-status.js';
import { Snowfall } from './marker-content-snowfall.js';
import { TemperatureLabel } from './marker-content-temp.js';
import { Wind } from './marker-content-wind.js';
import { MarkerComponentType, MarkerContentItem } from './utils.js';

export const PopulateMarkerArr = ({ contentArr }: { contentArr: MarkerContentItem[] }) => {
  return (
    <>
      {contentArr.map((c) => (
        <PopulateMarkerContent content={c} key={c.index} />
      ))}
    </>
  );
};

export const PopulateMarkerContent = ({ content }: { content: MarkerContentItem }) => {
  if (content.key) {
    switch (content.key) {
      case MarkerComponentType.Marine:
        return <MarineConditions {...content} key={content.key} />;
      case MarkerComponentType.SkiStatus:
        return <SkiStatus {...content} key={content.key} />;
      case MarkerComponentType.Snowfall:
        return <Snowfall {...content} key={content.key} />;
      case MarkerComponentType.FreezingLevel:
        return <FreezingLevel {...content} key={content.key} />;
      case MarkerComponentType.WindDisplay:
        return <Wind {...content} key={content.key} />;
      case MarkerComponentType.TempDisplay:
        return <TemperatureLabel {...content} key={content.key} />;
    }
  }
};
